<script>
import DataViewListVue from '@/app/arch/components/dataView/DataViewList.vue';

export default {
  name: 'OcrDataView',
  extends: DataViewListVue,
  data: (vm) => ({
    content: [
      {
        text: 'Nome completo',
        value: 'name',
      },
      {
        text: 'Data de nascimento',
        value: 'dateOfBirth',
        handle: vm.handleDateOfBirth,
      },
      {
        text: 'Nome da mãe',
        value: 'mothersName',
      },
      {
        text: 'Nome do pai',
        value: 'fathersName',
      },
      {
        text: 'Tipo de documento',
        value: 'documentType',
      },
      {
        text: 'CPF',
        value: 'cpf',
        handle: vm.handleCpf,
      },
      {
        text: 'RG',
        value: 'rg',
      },
    ],
  }),
};
</script>
